import React from "react";
import AifHoldingsTable from "../../components/HoldingsTable/AifHoldingsTable";
import HoldingsErrorDialog from "../../components/HoldingsTable/HoldingsErrorDialog";
import AppLoader from "../../components/AppLoader/AppLoader";
import { useUserHoldingsFetch } from "./useUserHoldingsFetch";

interface AIF {
  requestId: number;
  id: number;
  noteficationId: number;
  holdingName: string;
  category: string;
  investedAmount: number;
  currentAmount: number;
  transactionDate: string;
  currentNavDate: string;
  currentNAV: number;
  realisedPnL: number;
  transactions: [];
  xirr: string;
  days: number;
  unrealisedPnL: number;
  absolutePnL: number;
  type: string;
}

const AifHoldings: React.FC = () => {
  const {
    loader,
    errorMessage,
    setErrorMessage,
    data: AIF,
    pageSize,
    totalPages,
    currentPage,
    handlePageChange,
    handlePageSizeChange,
    fetchHoldings,
  } = useUserHoldingsFetch<AIF>("AIF", "Failed to load AIF holdings.");

  return (
    <>
      <AppLoader loading={loader} />
      <AifHoldingsTable
        data={AIF}
        totalPages={totalPages}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        fetchData={fetchHoldings}
      />
      <HoldingsErrorDialog
        open={Boolean(errorMessage)}
        message={errorMessage}
        title="Unable to load AIF holdings"
        onClose={() => setErrorMessage(null)}
      />
    </>
  );
};

export default AifHoldings;
